import { render, staticRenderFns } from "./PricingHistory.vue?vue&type=template&id=993e8a48&"
import script from "./PricingHistory.vue?vue&type=script&lang=ts&"
export * from "./PricingHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports